/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import ArrowDropDown from 'material-ui/svg-icons/navigation/arrow-drop-down'
import ArrowDropUp from 'material-ui/svg-icons/navigation/arrow-drop-up'
import { lightBlue500, grey400 } from 'material-ui/styles/colors'
import { convertNumberToDate } from 'helpers/timeHelpers'
import TableHeader from './TableHeader'
import TableCell from './TableCell'

const TableColumn = ({
  style,
  className,
  headerLabel,
  isDate,
  accessor,
  sortable,
  showSorter,
  sortType,
  onSortByKey,
  width,
  data,
  renderCell,
  cellProps,
  // hovering
  hoverIndex,
  setHoverIndex,
}) => {
  const createSorter = () => {
    switch (sortType) {
      case 'desc':
        return (
          <ArrowDropDown color={lightBlue500} />
        )
      case 'asc':
        return (
          <ArrowDropUp color={lightBlue500} />
        )
      default:
        return null
    }
  }
  return (
    <div
      className={cx('table-column', className)}
      style={{
        width,
        ...style,
      }}
    >
      <TableHeader
        renderSorter={() => (showSorter ? createSorter() : null)}
        onClick={() => sortable ? onSortByKey(accessor) : {}}
      >
        {headerLabel}
      </TableHeader>
      {data.map((item, index) => {
        const value = accessor ? item[accessor] : ''
        return (
          <TableCell
            key={index}
            {...cellProps}
            style={{ ...isDate && { color: grey400 }, ...cellProps.style }}
            className={cx(hoverIndex === index && 'active', cellProps.className)}
            onMouseEnter={() => setHoverIndex(index)}
            onMouseLeave={() => setHoverIndex(null)}
          >
            {renderCell ? (
              renderCell({
                value,
                rowData: item,
                index,
              })
            ) : (
              isDate ? convertNumberToDate(value) : value
            )}
          </TableCell>
        )
      })}
    </div>
  )
}

TableColumn.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  isDate: PropTypes.bool,
  headerLabel: PropTypes.string,
  accessor: PropTypes.string,
  showSorter: PropTypes.bool,
  sortType: PropTypes.oneOf(['asc', 'desc']),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  data: PropTypes.array,
  renderCell: PropTypes.func,
  hoverIndex: PropTypes.number,
  setHoverIndex: PropTypes.func.isRequired,
  cellProps: PropTypes.object,
  onSortByKey: PropTypes.func,
}
TableColumn.defaultProps = {
  style: {},
  accessor: '',
  className: '',
  headerLabel: '',
  isDate: false,
  showSorter: false,
  sortType: 'asc',
  width: 'auto',
  data: [],
  hoverIndex: undefined,
  renderCell: undefined,
  cellProps: {},
  onSortByKey: () => {},
}

export default TableColumn



// WEBPACK FOOTER //
// ./src/components/Table/tableElements/TableColumn.js